import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8k458pge3: FaireProductEntity = {
  token: "p_e8k458pge3",
  type: "product",
  name: "Enchanted Forest Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dcce871904c1e38b253c448d1939b7ca31ea947806648d802c0944a3d173e5bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a92aae35811520bd2caedbcf4e8aa58ad7d11c3465fc1555eb804d7458f842d1.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "When we were little we loved a game called Enchanted Forest... and while there were no owls with plaid accessories, this card captures all the magic we remember. Send some enchantment!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:35.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
